/*
 *
 *  remotes
 *
 */

import api from "../../helpers/Api"

export async function loadRecords(searchFilter) {
  let payload = { status: "active", mode: "DIVINE" }

  if (searchFilter) {
    return await api
      .post(`/list_equipment_mapping_detail`, searchFilter)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  } else {
    return await api
      .post(`/list_equipment_mapping_detail`, payload)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  }
}


/**
 *
 * @param {string} metaData
 * @returns
 */
export function loadRecordsMetaData(metaData, method) {
  if (method === "post") {
    return api
      .post(`/get_all_${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  } else {
    return api
      .get(`/get_all_${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  }
}



/**
 *
 * @param {object} record
 * @returns
 */
export function createRecord(record) {
  return api
    .post(`/add_equipment_mapping`, record)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}


/**
 *
 * @param {integer} id
 * @returns
 */
export function deleteRecord(deleteData) {
  return api
    .post(`/delete_equipment_mapped_detail`, deleteData)
    .catch((error) => Promise.reject(error))
}


const remotes = {
  loadRecords,
  loadRecordsMetaData,
  createRecord,
  deleteRecord,
}

export default remotes
